import { CheckBox, type CheckBoxProps } from 'components'
import { useContext } from 'react'
import { ScaleProps, useScale, useScaleProps } from '../../utils/scaleUtils'
import { ExplorerConfigContext } from '../providers/ExplorerConfigProvider'

export type Props = ScaleProps<CheckBoxProps>

export default function SCheckbox({ fontSize = 20, ...props }: Props) {
  const scale = useScale()
  const { theme } = useContext(ExplorerConfigContext)
  const { styleProps, rest } = useScaleProps({ ...props })
  const height = `${scale * fontSize}px`

  return (
    <CheckBox
      css={{
        '& .chakra-checkbox__control': {
          color: theme.color.black,
          height,
          width: height,
          borderWidth: `${scale * 2}px`,
          borderRadius: `${scale * 5}px`,
          _checked: { bg: theme.color.primary },
          _indeterminate: { bg: theme.color.primary },
        },
        '& svg': { fontSize: `${scale * fontSize * 0.7}px` },
        '& .chakra-checkbox__label': { fontSize: height },
        flexShrink: 0,
        gap: `${scale * 10}px`,
      }}
      {...styleProps}
      {...rest}
    />
  )
}
